import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {triggerTableRefresh} from 'cl-table/redux/actions';
import {
  realTimeUpdateUser,
  updateListingsPageSellers,
  removeSeller,
  updateNotifications,
  addSeller,
} from './RealTimeDBReducer';
import {updateTaskProgress} from 'MyAccount/ViewDesigns/redux/modules/general';
import pusher from 'shared/helpers/pusherConnection';
import {refreshListingsWithQuery, delayedSetPublishedCompleted} from 'MyAccount/Listings/listingsHelper';
import {
  removeDraft,
  updateTemplateS3VersionId,
  updateListings,
  updateListingsCounts,
} from 'MyAccount/ViewDesigns/redux/modules/listingsPage';
import InfoDialog from 'shared/components/Dialogs/InfoDialog/InfoDialog';
import InlineNotification, {
  LEVEL_ERROR,
} from 'crazyEditor/components/EditorUI/BaseUI/InlineMessages/InlineNotification';
import InlineButton from 'shared/components/InlineButton';
import {contactSupportWithMessage} from 'shared/helpers/analyticsHelper';
import {setRefreshingFromEbay} from 'MyAccount/ViewDesigns/redux/modules/listingsPage';
import {REVISE_STATUS} from '../globalConsts';
import {isDraftItemId} from 'shared/helpers/EbayListingsGeneralHelpers';
import {syncSellerListings} from '../ActionsManager/AmazonListingsActions/AmazonListingsActionsHelpers';
import {Tables} from 'cl-api';
import {AMAZON_CHANNEL} from 'cl-consts';

@connect(
  state => ({
    pusherChannel: state.user.pusher.channel,
    pusherKey: state.user.pusher.key,
  }),
  {
    triggerTableRefresh,
    updateListingsCounts,
    realTimeUpdateUser,
    updateListings,
    updateListingsPageSellers,
    removeSeller,
    addSeller,
    removeDraft,
    updateNotifications,
    updateTaskProgress,
    setRefreshingFromEbay,
    updateTemplateS3VersionId,
  }
)
export default class RealTimeDBListener extends Component {
  componentDidMount() {
    const {
      triggerTableRefresh,
      updateListingsCounts,
      updateTemplateS3VersionId,
      root,
      removeDraft,
      pusherKey,
      pusherChannel,
      updateListingsPageSellers,
      removeSeller,
      addSeller,
      updateNotifications,
      updateTaskProgress,
      realTimeUpdateUser,
    } = this.props;
    if (pusherKey) {
      const channel = pusher.subscribe(pusherChannel);
      channel.bind('listingReviseStatusUpdate', data => {
        this.updateListingStatus(data);
      });
      channel.bind('updateUserStore', data => {
        realTimeUpdateUser(JSON.parse(data).message);
      });
      channel.bind('listingsPageSellers', data => {
        updateListingsPageSellers(JSON.parse(data).message);
      });
      channel.bind('updateAddSeller', data => {
        const {channel, sellerData, error, marketplaceIds} = JSON.parse(data).message;
        if (!error && channel === AMAZON_CHANNEL) {
          syncSellerListings(sellerData.amazonSellerId);
        }
        addSeller(channel, sellerData, error, marketplaceIds);
      });
      channel.bind('sellerRemoved', data => {
        const {channel, sellerId} = JSON.parse(data).message;
        removeSeller(channel, sellerId);
      });
      if (root) {
        channel.bind('refresh', data => {
          if (_.isString(data)) {
            data = JSON.parse(data);
          }
          const {sellerId, updatedListingsIds, counts, refreshProductsTable} = data.message;
          if (refreshProductsTable) {
            triggerTableRefresh({name: Tables.InventoryTable});
          }
          if (!_.isEmpty(counts)) {
            updateListingsCounts(sellerId, counts);
          }
          if (!_.isEmpty(updatedListingsIds)) {
            refreshListingsWithQuery({itemIds: updatedListingsIds});
          }
        });
        channel.bind('refreshError', data => {
          const {setRefreshingFromEbay} = this.props;
          const {message, sellerId} = JSON.parse(data).message;
          const contactSupport = () =>
            contactSupportWithMessage(
              `I got this error while refreshing from eBay for ${sellerId}: ${message}, what should I do?`
            );
          setRefreshingFromEbay(false, sellerId, true);
          InfoDialog.info({
            title: 'Refresh from eBay failed for ' + sellerId,
            message: (
              <div>
                <div style={{marginBottom: 20, marginTop: 35}}>Refresh from eBay failed due to:</div>
                <InlineNotification style={{width: 820}} level={LEVEL_ERROR} animate={false}>
                  <div dangerouslySetInnerHTML={{__html: message}} />
                </InlineNotification>
                <div style={{marginTop: 20}}>
                  If you don’t know how to fix this you may{' '}
                  <InlineButton onClick={contactSupport}>ask for help</InlineButton> from Crazylister’s team. We are
                  always happy to help.
                </div>
              </div>
            ),
            level: 'error',
            cancelButtonLabel: 'report this',
            secondaryAction: contactSupport,
          });
        });
        channel.bind('activityRefresh', data => {
          _.forEach(JSON.parse(data).message, refreshIdentifier => {
            triggerTableRefresh({name: refreshIdentifier});
          });
        });
      }
      channel.bind('removeDraft', data => {
        const {sellerId, itemIds} = JSON.parse(data).message;
        removeDraft(sellerId, itemIds);
      });
      channel.bind('notificationsUpdated', data => {
        updateNotifications(JSON.parse(data).message.notifications);
      });
      channel.bind('updateTaskProgress', data => {
        updateTaskProgress(JSON.parse(data).message);
      });
      channel.bind('updateTemplateS3VersionId', data => {
        updateTemplateS3VersionId(JSON.parse(data).message);
      });
    }
  }

  pendingListingStatusUpdates = [];
  updateListingStatus = data => {
    if (_.isString(data)) {
      data = JSON.parse(data).message;
    }
    if (_.isArray(data)) {
      _.forEach(data, lisitngData => {
        this.pendingListingStatusUpdates.push(lisitngData);
      });
    } else {
      this.pendingListingStatusUpdates.push(data);
    }
    this.throttledUpdateListingStatus();
  };
  throttledUpdateListingStatus = _.throttle(() => {
    const {updateListings} = this.props;
    updateListings(this.pendingListingStatusUpdates, true);
    delayedSetPublishedCompleted();
    _.forEach(
      _.groupBy(
        _.filter(
          this.pendingListingStatusUpdates,
          ({reviseStatus, itemID}) =>
            reviseStatus === REVISE_STATUS.SUCCESS || (isDraftItemId(itemID) && reviseStatus === REVISE_STATUS.ERROR)
        ),
        'sellerId'
      ),
      (listings, sellerId) => {
        refreshListingsWithQuery({sellerId, itemIds: _.map(listings, 'itemID')});
      }
    );
    this.pendingListingStatusUpdates = [];
  }, 5000);

  render() {
    return null;
  }
}
